module.exports = __webpack_public_path__ + "static/media/telegram_logo.74ac3919.svg";